import styled, {css} from "styled-components";

export const BoxStyled = styled.div<any>`
  display: flex;
  padding: ${(props) => props.p};
`;
export const ButtonStyled = styled.button<any>`
  width: 100%;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  background-color: #e60000;
  font-size: 20px;
  line-height: 1.4;
  text-align: center;
  color: #fff;

  &:disabled {
    background-color: #ccc;

    &:hover {
      cursor: default;
      background-color: #ccc;
    }

    @media screen and (max-width: 480px) {
      min-height: 40px;
      padding: 8px 16px;
    }
  }

  ${({active}) => active && css`
    border-radius: 6px;
    background-color: #009900;

    span, img {
      border-radius: 50%;
      margin-right: 10px;
      position: relative;
      top: 2px;
    }

    &:hover {
      background-color: darkgreen !important;
    }
  `}
  &:hover {
    cursor: pointer;
    background-color: #900;
    transition: background-color 0.2s ease-in-out;
  }

  @media screen and (max-width: 480px) {
    height: 40px;
    padding: 8px 16px;
    font-size: 18px;
  }
`;
